exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'cat';\n  src: url(\"/assets/fonts/cat.eot?vcfb5d\");\n  src: url(\"/assets/fonts/cat.eot?vcfb5d#iefix\") format(\"embedded-opentype\"), url(\"/assets/fonts/cat.ttf?vcfb5d\") format(\"truetype\"), url(\"/assets/fonts/cat.woff?vcfb5d\") format(\"woff\"), url(\"/assets/fonts/cat.svg?vcfb5d#cat\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n:host .section:last-child {\n  border-bottom: 0; }\n\n:host .section .inner {\n  padding-top: 1rem;\n  padding-right: 1rem;\n  padding-bottom: 1rem;\n  padding-left: 1rem; }\n\n:host .active {\n  background-color: #4CAF50;\n  margin: 0;\n  cursor: pointer; }\n\n:host .inactive {\n  background-color: #f44336;\n  margin: 0;\n  cursor: pointer; }\n\n:host ::ng-deep .fa-times {\n  color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-option-tokens/components/project-option-tokens/project-option-tokens.component.scss
// module id = ../../../../../src/app/modules/models/project-option-tokens/components/project-option-tokens/project-option-tokens.component.scss
// module chunks = main